import { validateLicense } from "components/StraightThroughHouseholdComp/CustomInputs/StateObjects/ValidateLicense";
import { validateAddress } from "services/Api";

export const AddDriver_ValidateFields = async ({ context, session }) => {
  // console.log(context, session)
  if (Object.keys(session)?.length === 0) {
    return;
  }

  // Run validations concurrently
  var validationPromises = [
    ValidateEffDate(session),
    ValidateFullName(session),
    ValidateDOB(session),
    ValidateMaritalStatus(session),
    ValidateGender(session),
    ValidateLicenseStatus(session),
    ValidateAgeLicensed(session),
    ValidateLicenseState(session),
    ValidateLicenseCountry(session),
    ValidateLicenseNumber(session, context),
    ValidateRelationshipToPolicyholder(session),
    ValidateSameHousehold(session),
    ValidateHouseholdAddress(session, context),
    ValidateResideInState(session, context),
    ValidateOccupation(session),
    ValidateStudent(session),
    ValidateConviction(session, context),
    ValidateMilitary(session),
    ValidateDisorders(session),
    ValidatePhysicalImpairments(session, context),
    ValidateDiffNameLicensed(session, context),
    ValidateDiffStateLicensed(session, context),
    ValidateMovingViolations(session),
    ValidateSuspended(session, context),
    ValidateCustody(session, context),
    ValidateSeriousMovingViolations(session, context),
    ValidateUnderInfluence(session, context),
    ValidateImpairment(session, context),
    ValidateFailureToStopInjury(session, context),
    ValidateVehicleDamage(session, context),
    ValidateProvideInfoFailure(session, context),
    ValidateRecklessDriving(session, context),
  ];

  const validationResults = await Promise.all(validationPromises);
  var invalidResults = validationResults.filter(
    (result) => result.valid === false
  );

  return invalidResults;
};

const Validate = (value) => {
  if (value == undefined) {
    // No input on the screen
    return false;
  } else if (value == "" || value == "Select from the following...") {
    // Input on screen value not filled
    return true;
  } else {
    // Input is filled
    return false;
  }
};

const ValidateEffDate = async (session) => {
  if(Validate(session?.requestedEffDate)){
      return { title: "Oops!", message: 'Please enter a valid Requested Effective Date.', valid: false };
  }
  return { valid: true }
}

const ValidateFullName = async (session) => {
  if (
    Validate(session?.userInfo?.firstName) ||
    Validate(session?.userInfo?.lastName)
  ) {
    return {
      title: "Oops!",
      message: "Please enter your full name.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateDOB = async (session) => {
  if (
    invalidDate(
      `${session?.userInfo?.dobMonth} ${session?.userInfo?.dobDay}, ${session?.userInfo?.dobYear}`
    ) &&
    !(
      Validate(session?.userInfo?.dobMonth) ||
      Validate(session?.userInfo?.dobDay) ||
      Validate(session?.userInfo?.dobYear) ||
      session?.userInfo?.dobMonth == "Month" ||
      session?.userInfo?.dobDay == "Day" ||
      session?.userInfo?.dobYear == "Year"
    )
  ) {
    var date = new Date(`${session?.userInfo?.dobMonth} ${session?.userInfo?.dobDay}, ${session?.userInfo?.dobYear}`);
    if (date.toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" }) != `${session?.userInfo?.dobMonth} ${session?.userInfo?.dobDay}, ${session?.userInfo?.dobYear}`) {
      return {
        title: "Oops!",
        message: "Please enter a valid date of birth.",
        valid: false,
      };
    } else {
      return {
        title: "Oops!",
        message:
          "Please enter a date for a driver that is 16 years old or older, drivers cannot be less than 16 years old.",
        valid: false,
      };
    }
  } else if (
    Validate(session?.userInfo?.dobMonth) ||
    Validate(session?.userInfo?.dobDay) ||
    Validate(session?.userInfo?.dobYear) ||
    session?.userInfo?.dobMonth == "Month" ||
    session?.userInfo?.dobDay == "Day" ||
    session?.userInfo?.dobYear == "Year"
  ) {
    return {
      title: "Oops!",
      message: "Please enter your date of birth.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateMaritalStatus = async (session) => {
  if (Validate(session?.userInfo?.maritalStatus)) {
    return {
      title: "Oops!",
      message: "Please enter your marital status.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateGender = async (session) => {
  if (Validate(session?.userInfo?.gender)) {
    return {
      title: "Oops!",
      message: "Please enter your gender.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateLicenseStatus = async (session) => {
  if (Validate(session?.driverInfo?.licenseStatus)) {
    return {
      title: "Oops!",
      message: "Please provide the current status of this driver's license.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateAgeLicensed = async (session) => {
  if (
    session?.driverInfo?.licenseStatus !== "Valid Foreign License" &&
    Validate(session?.driverInfo?.licenseAge)
  ) {
    return {
      title: "Oops!",
      message: "Please enter the age this driver was licensed.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateLicenseState = async (session) => {
  if (
    session?.driverInfo?.licenseStatus !== "Valid Foreign License" &&
    Validate(session?.driverInfo?.licenseState)
  ) {
    return {
      title: "Oops!",
      message: "Please enter the state licensed for this driver.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateLicenseCountry = async (session) => {
  if (
    session?.driverInfo?.licenseStatus === "Valid Foreign License" &&
    Validate(session?.driverInfo?.licenseCountry)
  ) {
    return {
      title: "Oops!",
      message: "Please enter the country licensed for this driver.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateLicenseNumber = async (session, context) => {
  if (Validate(session?.driverInfo?.licenseNumber)) {
    return {
      title: "Oops!",
      message: "Please enter the license number for this driver.",
      valid: false,
    };
  }

  if (session?.driverInfo?.licenseNumber && validateLicense(session?.driverInfo?.licenseState, session?.driverInfo?.licenseNumber)) {
    return { title: "Oops!", message: 'Please enter the correct format for a license number.', valid: false };
  }
  return { valid: true };
};
const ValidateRelationshipToPolicyholder = async (session) => {
  if (Validate(session?.userInfo?.relationshipToPolicyholder)) {
    return {
      title: "Oops!",
      message:
        "Please enter the relationship of this driver to the policyholder.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateSameHousehold = async (session) => {
  if (Validate(session?.addressInfo?.sameHousehold)) {
    return {
      title: "Oops!",
      message: "Please provide if this driver resides in the same household.",
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateHouseholdAddress = async (session, context) => {
  const ValidateFields = Validate(session?.addressInfo?.driverStreetName) ||
    Validate(session?.addressInfo?.driverCity) ||
    Validate(session?.addressInfo?.driverZip);
  if (ValidateFields) {
    return {
      title: "Oops!",
      message: "Please provide the driver's address.",
      valid: false,
    };
  }
  if (session?.addressInfo?.driverCity && session?.addressInfo?.driverZip && session?.addressInfo?.driverStreetName) {
    var data = {}
    data["addrTypeCd"] = "ContactAddr"
    data["addr1"] = session?.addressInfo?.driverStreetName
    data["city"] = session?.addressInfo?.driverCity
    data["postalCode"] = session?.addressInfo?.driverZip
    data["stateProvCd"] = context.getStateAbbr(context?.userData?.state);
    data["regionCd"] = "US"
    data["regionISOCd"] = "US"
    const response = await validateAddress(data)
    if (response.data == "Invalid") {
      return {
        title: "Oops!",
        message: "Please provide a valid driver address.",
        valid: false,
      }
    }
  }
  return { valid: true };
};
const ValidateResideInState = async (session, context) => {
  if (Validate(session?.addressInfo?.resideInState)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver resides in ${context?.userData?.state}.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateOccupation = async (session) => {
  if (Validate(session?.userInfo?.occupation)) {
    return {
      title: "Oops!",
      message: `Please provide this driver's occupation.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateStudent = async (session) => {
  if (Validate(session?.schoolInfo?.enrolledInCollege)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver is enrolled in college/university.`,
      valid: false,
    };
  }
  if (Validate(session?.schoolInfo?.school100Miles)) {
    return {
      title: "Oops!",
      message: `Please provide if the school is over 100 miles away from the policy address.`,
      valid: false,
    };
  }
  if (Validate(session?.schoolInfo?.schoolName)) {
    return {
      title: "Oops!",
      message: `Please provide the school name.`,
      valid: false,
    };
  }
  if (Validate(session?.schoolInfo?.schoolCity)) {
    return {
      title: "Oops!",
      message: `Please provide the school city.`,
      valid: false,
    };
  }
  if (Validate(session?.schoolInfo?.schoolState)) {
    return {
      title: "Oops!",
      message: `Please provide the school state.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateConviction = async (session, context) => {
  if (Validate(session?.violationInfo?.convicted)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has been convicted within the last 5 years of fraud or intent to defraud involving an insurance claim
            or an application for insurance.`,
      valid: false,
    };
  }
  return { valid: true };
};

const ValidateMilitary = async (session) => {
  if (Validate(session?.userInfo?.militaryMember)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver is a member of any branch of military.`,
      valid: false,
    };
  }
  return { valid: true };
};

const ValidateDisorders = async (session) => {
  if (Validate(session?.disabilityInfo?.disorders)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has any disorders/conditions that may impair their ability to operate a motor vehicle.`,
      valid: false,
    };
  }
  return { valid: true };
};

const ValidatePhysicalImpairments = async (session, context) => {
  if (Validate(session?.disabilityInfo?.physicalImpairments)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has any mental/physical impairments that would impair their ability to operate a motor vehicle.`,
      valid: false,
    };
  }
  return { valid: true };
};

const ValidateDiffNameLicensed = async (session, context) => {
  if (Validate(session?.driverInfo?.diffNameLicensed)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has been licensed under a different name within the last 36 months.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateDiffStateLicensed = async (session, context) => {
  if (Validate(session?.driverInfo?.diffStateLicensed)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has been licensed under a different state within the last 36 months.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateMovingViolations = async (session) => {
  if (Validate(session?.violationInfo?.movingViolations)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver received any moving violations and/or been in any accidents or claims within the last 36 months.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateSuspended = async (session, context) => {
  if (Validate(session?.violationInfo?.driverSuspended)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver's license has been suspended or in a suspended status within the last 36 months.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateCustody = async (session, context) => {
  if (Validate(session?.userInfo?.minorCustody)) {
    return {
      title: "Oops!",
      message: `Please provide if this applicant have custody of a minor.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateSeriousMovingViolations = async (session, context) => {
  if (Validate(session?.violationInfo?.seriousMovingViolations)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver received any moving violations that resulted in death
            or serious impairment of body function within the last 3 years.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateUnderInfluence = async (session, context) => {
  if (Validate(session?.violationInfo?.underInfluence)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has operated a motor vehicle while under influence within the last 3 years.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateImpairment = async (session, context) => {
  if (Validate(session?.violationInfo?.impairment)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has failed to stop when involved in an accident that results in serious impairment of a body function
            or death within the last 3 years.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateFailureToStopInjury = async (session, context) => {
  if (Validate(session?.violationInfo?.ftsInjury)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has failed to stop when involved in an accident that results in injury
            to any individual within the last 3 years.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateVehicleDamage = async (session, context) => {
  if (Validate(session?.violationInfo?.vehicleDamage)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has failed to stop when involved in an accident that results in damage
            to a vehicle operated by or attended by any individual within the last 3 years.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateProvideInfoFailure = async (session, context) => {
  if (Validate(session?.violationInfo?.provideInfoFailure)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has failed to provide required information or to provide reasonable
            assistance to an injured individual within the last 3 years.`,
      valid: false,
    };
  }
  return { valid: true };
};
const ValidateRecklessDriving = async (session, context) => {
  if (Validate(session?.violationInfo?.recklessDriving)) {
    return {
      title: "Oops!",
      message: `Please provide if this driver has record of reckless driving, or a similar violation under the laws 
            of any other state or municipality in or outside of Michigan within the last 3 years.`,
      valid: false,
    };
  }
  return { valid: true };
};

const invalidDate = (dateString) => {
  const date = new Date(dateString);

  // Step 1: Check if the date is valid
  if (isNaN(date.getTime())) return true; // Invalid date format

  // Step 2: Ensure the parsed date matches the input (to prevent invalid dates like Feb 31)
  const reconstructedDate = date.toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" });
  if (reconstructedDate !== dateString) return true; // Mismatched input means invalid date

  // Step 3: Ensure the date is at least 16 years in the past
  const today = new Date();
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 16);

  return date > minDate; // Returns true if the date is less than 16 years ago
};

